import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b', STAR = '#ff8a00';

export default function AppPartnerDashboard() {
  const navigate = useNavigate();
  const [salon, setSalon] = useState(null);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const uid = localStorage.getItem('salonId') || localStorage.getItem('firebaseUid');
        if (uid) {
          const r = await axios.get(`${API}/salon/user/${uid}`, { timeout: 12000 });
          setSalon(r.data);
          setIsOpen(r.data?.current_status !== 'closed');
        }
      } catch (e) { /* salon may not be set up */ }
      setLoading(false);
    };
    load();
  }, []);

  const stat = (val, label, color) => (
    <div style={{ flex: 1, background: color || '#fff', borderRadius: 16, padding: 16, boxShadow: color ? 'none' : '0 3px 12px rgba(28,28,40,.06)', color: color ? '#fff' : INK }}>
      <div style={{ fontSize: 24, fontWeight: 800 }}>{val}</div>
      <div style={{ fontSize: 11, opacity: color ? 0.9 : 1, color: color ? '#fff' : GREY, marginTop: 2 }}>{label}</div>
    </div>
  );

  const Row = ({ i, t, badge, badgeColor, onClick }) => (
    <div onClick={onClick || (() => toast.info('Yeh feature jald aa raha hai'))} style={{ background: '#fff', borderRadius: 14, padding: 16, display: 'flex', alignItems: 'center', gap: 14, margin: '0 16px 10px', cursor: 'pointer', boxShadow: '0 2px 8px rgba(28,28,40,.04)' }}>
      <span style={{ fontSize: 20, width: 24, textAlign: 'center' }}>{i}</span>
      <span style={{ fontSize: 14, fontWeight: 600, color: INK, flex: 1 }}>{t}</span>
      {badge && <span style={{ background: badgeColor || RED, color: '#fff', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20 }}>{badge}</span>}
      <span style={{ color: GREY, fontSize: 18 }}>›</span>
    </div>
  );

  const secTitle = (t) => <div style={{ fontSize: 12, fontWeight: 800, color: GREY, padding: '16px 20px 8px', letterSpacing: '0.04em' }}>{t}</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto', paddingBottom: 40 }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '26px 16px 22px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <div style={{ width: 48, height: 48, borderRadius: 14, background: '#fff', color: RED, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>💈</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>{salon?.salon_name || 'My Salon'}</div>
          <div style={{ fontSize: 13, opacity: 0.9, marginTop: 2 }}>Partner Dashboard · <span style={{ color: '#7fffb0' }}>● {isOpen ? 'Open' : 'Closed'}</span></div>
        </div>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 22, cursor: 'pointer' }}>‹</span>
      </div>

      {/* stats */}
      <div style={{ display: 'flex', gap: 10, padding: 16 }}>
        {stat('₹0', 'Aaj ki kamai', `linear-gradient(135deg,${RED},${RED_D})`)}
        {stat(pending.length, 'Pending')}
        {stat(salon?.rating || '—', 'Rating')}
      </div>

      {/* open/close toggle */}
      <div style={{ margin: '0 16px 4px', background: '#fff', borderRadius: 14, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 2px 8px rgba(28,28,40,.04)' }}>
        <span style={{ fontSize: 20 }}>{isOpen ? '🟢' : '🔴'}</span>
        <div style={{ flex: 1 }}><div style={{ fontSize: 14, fontWeight: 700, color: INK }}>Salon is {isOpen ? 'Open' : 'Closed'}</div><div style={{ fontSize: 11, color: GREY }}>Tap to {isOpen ? 'close' : 'open'}</div></div>
        <div onClick={() => setIsOpen(!isOpen)} style={{ width: 46, height: 26, background: isOpen ? GREEN : '#ccc', borderRadius: 20, position: 'relative', cursor: 'pointer', transition: 'background .2s' }}>
          <div style={{ width: 20, height: 20, background: '#fff', borderRadius: '50%', position: 'absolute', top: 3, left: isOpen ? 23 : 3, transition: 'left .2s' }} />
        </div>
      </div>

      {/* pending bookings */}
      {secTitle('NEW BOOKINGS')}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 20, color: GREY }}>Loading...</div>
      ) : pending.length === 0 ? (
        <div style={{ margin: '0 16px', background: '#fff', borderRadius: 14, padding: 24, textAlign: 'center', color: GREY, fontSize: 13, boxShadow: '0 2px 8px rgba(28,28,40,.04)' }}>
          Abhi koi nayi booking nahi.<br />Jab customer book karega, yahan turant dikhega.
        </div>
      ) : (
        pending.map((b, i) => (
          <div key={i} style={{ margin: '0 16px 12px', background: '#fff', borderRadius: 16, padding: 16, boxShadow: '0 3px 12px rgba(28,28,40,.06)', borderLeft: `4px solid ${STAR}` }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{b.customer_name || 'Customer'}</div>
            <div style={{ fontSize: 12, color: INK, marginTop: 6, fontWeight: 600 }}>📅 {b.booking_date} · {b.slot_time}</div>
            <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
              <button style={{ flex: 1, borderRadius: 10, padding: 11, fontSize: 13, fontWeight: 700, border: '1.5px solid #ef4444', background: '#fff', color: '#ef4444', cursor: 'pointer' }}>✕ Reject</button>
              <button style={{ flex: 2, borderRadius: 10, padding: 11, fontSize: 13, fontWeight: 700, border: 'none', background: GREEN, color: '#fff', cursor: 'pointer' }}>✓ Accept</button>
            </div>
          </div>
        ))
      )}

      {secTitle('MANAGE')}
      <Row i="📅" t="Bookings" onClick={() => navigate('/salon/dashboard')} />
      <Row i="✂️" t="Services & Prices" onClick={() => navigate('/salon/dashboard')} />
      <Row i="📸" t="Photos & Gallery" onClick={() => navigate('/salon/dashboard')} />
      <Row i="🕐" t="Timings & Availability" onClick={() => navigate('/salon/dashboard')} />
      <Row i="👥" t="Staff Management" onClick={() => navigate('/salon/dashboard')} />

      {secTitle('BUSINESS')}
      <Row i="📊" t="Earnings & Reports" onClick={() => navigate('/salon/dashboard')} />
      <Row i="📈" t="Analytics" onClick={() => navigate('/salon/dashboard')} />
      <Row i="⭐" t="Reviews & Ratings" onClick={() => navigate('/salon/dashboard')} />
      <Row i="💳" t="Subscription" badge="Active" badgeColor={GREEN} onClick={() => navigate('/salon/dashboard')} />
      <Row i="⚙️" t="Salon Settings" onClick={() => navigate('/salon/dashboard')} />

      <div style={{ textAlign: 'center', padding: 16, color: GREY, fontSize: 11 }}>Made with ❤️ in India 🇮🇳</div>
    </div>
  );
}
